import React, { useState } from "react";

import ReportItemHeader from "../common/ReportItemHeader";
import ChartLegend from "../common/ChartLegend";
import DoughnutChart from "../common/DoughnutChart";

import lbl from "../../data/Labels.json";

const FinanceProfileChart = ({ data }) => {
  const chartData = [
    {
      label: lbl.Present,
      value: data?.present_count || 0,
      color: "#48C29D",
    },
    {
      label: lbl.Absent,
      value: data?.absent_count || 0,
      color: "#9A3859",
    },
    {
      label: lbl.Holiday,
      value: data?.holiday_count || 0,
      color: "#EF9C0E",
    },
  ];

  const [shrink, setShrink] = useState(false);

  return data ? (
    <div className={`report-container _25-per ${shrink && "shrink"}`}>
      <ReportItemHeader
        title={`${data?.month} ${data?.year}`}
        shrink={shrink}
        setShrink={setShrink}
      />
      <div className="chart">
        <DoughnutChart data={chartData} />
      </div>
      <div className="chart-legend">
        <ChartLegend data={chartData} symbol={"d"} />
      </div>
    </div>
  ) : null;
};

export default FinanceProfileChart;
